import React, { useEffect } from 'react';
import { DashboardProvider, useDashboard } from '../../alumni-activity-dashboard/DashboardContext';
import { useVibrancy } from '../VibrancyDashboardContext';
import { COMPARE_OPTIONS, Period } from '../vibrancyDashboardService';
import CampaignActivity from '../../alumni-activity-dashboard/components/CampaignActivity';
import EventActivity    from '../../alumni-activity-dashboard/components/EventActivity';
import OtherActivityGrid from '../../alumni-activity-dashboard/components/OtherActivityGrid';
import { SectionDivider } from './shared';

/**
 * Inner component — runs inside DashboardProvider so it can call useDashboard().
 * Syncs vibrancy context (institute + period) → activity dashboard context,
 * then renders the three activity-section components unchanged.
 */
const ActivityBridgeInner: React.FC<{ period?: Period }> = ({ period }) => {
    const { selectedInstituteId, timeframe: globalTimeframe, compareMode, comparePeriod } = useVibrancy();
    const timeframe = period ?? globalTimeframe;   // section period overrides the global one
    const { setSelectedInstitute, setTimeframe } = useDashboard();

    // Sync institute → activity dashboard context whenever it changes
    useEffect(() => {
        setSelectedInstitute(selectedInstituteId ? Number(selectedInstituteId) : null, '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedInstituteId]);

    // Sync period → activity dashboard context whenever it changes
    useEffect(() => {
        setTimeframe(timeframe as any);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [timeframe]);

    const prevOptions     = COMPARE_OPTIONS[timeframe] || [];
    const prevPeriodLabel = comparePeriod || prevOptions[0] || '';

    return (
        <>
            <CampaignActivity compareMode={compareMode} prevPeriodLabel={prevPeriodLabel} />
            <EventActivity />
            <OtherActivityGrid compareMode={compareMode} />
        </>
    );
};

/**
 * Outer wrapper — mounts DashboardProvider only when an institute is selected.
 * The activity-dashboard components (CampaignActivity, EventActivity,
 * OtherActivityGrid) are used exactly as they are, with no modification.
 */
const ActivitySectionBridge: React.FC<{ period?: Period }> = ({ period }) => {
    const { instituteLoaded } = useVibrancy();
    if (!instituteLoaded) return null;

    return (
        <>
            {/* <SectionDivider
                icon="⚡"
                title="Activity Stats & Metrics"
                note="alumni & student self-driven actions — campaigns, platform, events"
            /> */}
            <DashboardProvider>
                <ActivityBridgeInner period={period} />
            </DashboardProvider>
        </>
    );
};

export default ActivitySectionBridge;
